import React, { useContext, useEffect } from 'react';
import withAuthorisation from '../../components/auth/WithAuthorisation';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { StartButton } from '../../components/Govuk';
import { OneOffAuthContext } from '../../components/oneOffAuth/OneOffAuthContext';
import { AuthContext } from '../../components/auth/AuthContext';

const Login = () => {
  const { trackPageView, trackEvent } = useMatomo();
  useEffect(() => {
    trackPageView({
      documentTitle: 'Login - Report Suspicious Chemical Activity',
    });
    trackEvent({
      category: 'Login Page',
      action: 'Visited',
    });
  }, [trackPageView, trackEvent]);
  const { isOneOffAuthenticated } = useContext(OneOffAuthContext);
  const { handleLogin } = useContext(AuthContext);
  const login = (e) => {
    e.preventDefault();
    handleLogin('/home');
  };
  return (
    <>
      <main
          className="govuk-main-wrapper"
          id="content"
          role="main"
          data-testid="content"
          tabIndex={0}
      >
        <div className="govuk-grid-column">
          <h1 className="govuk-heading-l" tabIndex="0">
            Make a report
          </h1>
          <p className="govuk-body" tabIndex="0" data-test="one-off-body">
            If you cannot use this online service, call the anti-terrorism hotline on <a href="tel:0800789321">0800 789
            321</a>. The hotline is staffed 24/7.
          </p>
          <p className="govuk-body" tabIndex="0">
            You need to validate your email address to submit a report. Provide your email and a link to the reporting
            form will be emailed to you.
          </p>
          <StartButton
            content={'Validate your email'}
            url={isOneOffAuthenticated() ? 'sar/before-starting' : 'sar-registration'}
            dataTest="data-start-button"
            aria-label="Validate your email to start reporting"
          />
          <h2 className="govuk-heading-m" tabIndex="0" data-test="regular-reporting-header">
            Account holders
          </h2>
          <p className="govuk-body" tabIndex="0">
            <a
              href="#"
              className="govuk-link"
              onClick={login}
              data-test="regular-reporting-link"
              aria-label="Sign in to your account"
            >
              Sign in to your account
              {' '}
            </a>
            if you have agreed to provide data regularly to the Home Office.
          </p>
          <h2 className="govuk-heading-m" tabIndex="0" data-test="contact-header">
            Help with reporting
          </h2>
          <p className="govuk-body" tabIndex="0" data-test="contact-body">
            For questions about reporting, email {' '}
            <a
              href="mailto:ChemicalReportingTeam@homeoffice.gov.uk"
              data-test="contact-crt-email"
            >
              ChemicalReportingTeam@homeoffice.gov.uk
            </a>
          </p>
          <p className="govuk-body" tabIndex="0">
            This email is monitored Monday to Friday, 9am to 5pm (except bank holidays).
          </p>
        </div>
      </main>
    </>
  );
};

const LoginWithAuth = withAuthorisation({
  forwardUrl: '/home',
  isLoginPage: true,
})(Login);
export { LoginWithAuth as Login };
